import { IState, Country, State } from 'country-state-city';
import { environment } from './../../../../../environment/environment';
import { SortDataService } from './../../../../core/services/sortdata';
import { Component, ElementRef, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  fileTypeExtention,
  serverError,
} from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { EsnclientService } from './../../../../core/services/esnclient/esnclient.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import { Subject, takeUntil } from 'rxjs';
import { linkedCompanyRegExp, patternEmail, urlRegExp } from './../../../../core/models/pattern';
import * as saveAs from 'file-saver';
import { headerColumns10 } from './../../../../core/models/fournisseur';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { PhoneNumberFormat } from 'ngx-intl-telephone-input';
import { translations } from '../../../../core/models/call-offer';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-liste-clients',
  templateUrl: './liste-clients.component.html',
  styleUrls: ['./liste-clients.component.css'],
})
export class ListeClientsComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  loadSpinner: boolean = false;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  currentSortDirection: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  totalItems!: number;
  skills: any = [];
  name: any = [];
  isexiste = false;
  client_id: any;
  searchElement: string = '';
  isDisabled = true;
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  isLoadSpinner: boolean = true;

  countries: any = [];
  stateList!: IState[];
  backGroundColors: string[] = [
    'blue',
    'orange',
    'bleu-clair',
    'pink',
    'rose',
    'jaune',
    'rouge',
  ];
  sortAttr = '';
  addBulk!: FormGroup;
  fileBulkError: any;
  fileExtentions: string = '';
  selectedFile: File | null = null;

  listclients: any;
  urlimage: string = environment.baseUrlGalery;
  urlcv: string = environment.baseUrlGaleryCv;
  url: string = environment.baseUrl + '/api';
  loadSpinnerTable: boolean = false;
  searchForm: FormGroup = this.createSearchForm();
  updateform!: FormGroup;
  skillsList: { name_FR: string }[] = [];
  currentSortColumn: string = 'name'; // Initial column to sort by
  seeMore: boolean = false;
  types: any = [];
  formclient: FormGroup = this.createclientForm();

  modalRef?: BsModalRef;
  isCollapsed = true;
  private unsubscribeAll: Subject<void> = new Subject();
  clientSearchErrorMessage: string | null = null;
  today = new Date();
  currentDate!: string;
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
client = {
  average_note: 1, // or the initial value of your note
};
  data: any[] = [
    {
      competences: [
        'nom',
        'site_web',
        'linkedin',
        'nombre_jours_de_prestation',
        'taille_entreprise',
        'pays',
        'localisation',
        'domaine',
        'annee_creation',
        'nom_vis_a_vis',
        'prenom_vis_a_vis',
        'mail_vis_a_vis',
        'num_vis_a_vis',
      ],
    },
  ];
  id: any;
  fileErr: boolean = false;
  minDate!: string;
  isexistname = false;
  typeintervenant: any;
  dataHeader: any = [];
  listNames: string[] = [];
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns10;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  SearchCountryField = SearchCountryField;
  separateDialCode: boolean = false;
  pagination : boolean =false;
  isDisabledd: boolean = true;

  PhoneNumberFormat = PhoneNumberFormat;

  startSearching:boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private sortDataService: SortDataService,
    private clientservice: EsnclientService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef
  ) {
    const day = String(this.today.getDate()).padStart(2, "0");
    const month = String(this.today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
    // Set the minimum date to 10 years ago, for example
    const minYear = 1990;
    this.minDate = `${minYear}-${month}-${day}`;
  }
  ngOnInit() {
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.getListclient();
    this.setValidatorRequirements();
    this.getListElementHeader();
    this.countries = Country.getAllCountries();
    this.updateform = this.formBuilder.group({
      id: ['', Validators.required],
      name: ['', Validators.required],
      city: ['', Validators.required],
      country: ['', Validators.required],
      post_type: ['', Validators.required],
      contract_type: ['', Validators.required],
      availability: ['', Validators.required],
      skills: ['', Validators.required],
      years_of_experience: ['', Validators.required],
      tjm: ['', Validators.required],
      salary: ['', Validators.required],
      description: ['', Validators.required],
    });
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }
  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  createclientForm(data?: any) {
    return this.formBuilder.group({
      name: [data?.name || '', [Validators.required]],
      related_first_name_ESN: [data?.nom_vis_a_vis || null],
      related_last_name_ESN: [data?.prenom_vis_a_vis
        || null],
      related_email_ESN: [data?.email_vis_a_vis || null , [ Validators.required, Validators.email, Validators.pattern(patternEmail)]],
      country: [data?.country || null],
      address: [data?.address || null],
      related_phone_ESN: [data?.num_vis_a_vis || null],
      linkedin_link: [data ? data.linkedin_link : "", [Validators.pattern(linkedCompanyRegExp)]],
      website_link: [data ? data.website_link : "", [Validators.pattern(urlRegExp)]],
      year_of_creation:[data ?new Date(data.year_of_creation).getFullYear().toString() : ''],
      date_first_presentation: [data?.date_first_presentation || null],
      nb_days: [data?.nb_days || ''],
      client_id: this.id,
    });
  }
  createFormPhone(data?: any) {
    return this.formBuilder.group({
      phone: [data && data.phone],
    });
  }
  toastMessages: ToastMessage = {
    success: 'Client ajouté avec succès',
    error: 'Client avec ce nom existe déjà',
  };

  openModalBulk(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.updateform.get('open_for_mission')?.setValue(1);
    this.fileExtentions = '';
  }
  /*download file add bulk */
  downloadCsv() {
    this.clientservice.downloadcsvfileAddBulkClient().subscribe({
      next: (res: Blob) => {
        const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'ajout en masse esn client.csv');
      },
      error: (err) => {
        // Handle the error appropriately
      },
    });
  }
 
  formAddBulk() {
    this.addBulk = this.formBuilder.group({
      file: [null, [Validators.required]],
    });
  }

  /*select file and add Bulk Candidates */
  onFileSelected(event: any) {
    this.fileErr = false;
    this.fileExtentions = '';
    this.selectedFile = event.target.files[0];

    if (this.selectedFile) {
      const fileExtension = this.selectedFile.name
        .toLowerCase()
        .substr(this.selectedFile.name.lastIndexOf('.'));
      const allowedExtensions = ['.csv', '.xlsx', '.xls'];
      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtentions = fileTypeExtention;
        this.fileErr = true;
      }
    }
  }
  translateCountryName(name: string): string {
  
    return translations[name] || name;
  }
  addBulkCandidates() {
    if (this.selectedFile) {
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      this.spinner.show();
      this.clientservice.addBulkCandidates(formData).subscribe({
        next: (res: any) => {
          this.spinner.hide();

          this.fileBulkError = res.export_file;
          this.getbulkCandidate(this.fileBulkError);
          this.toastrService.success('Fichier importé avec succès');
          this.closeModal();
          this.selectedFile = null;
          this.currentPage = 0
          this.getListclient()
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error?.message) {
              if (err.error.message === 'File contains only headers.') {
                this.toastrService.error('Le fichier est vide');
              } else if (
                err.error.message ===
                'File headers do not match the expected headers.'
              ) {
                this.toastrService.error(
                  'Les en-têtes de fichiers ne correspondent pas aux en-têtes attendus.'
                );
              } else {
                this.toastrService.error(serverError);
              }
            } else {
              this.toastrService.error(serverError);
            }
            this.closeModal();
            this.selectedFile = null;
          }
        },
      });
    }
  }
  getbulkCandidate(file: File) {
    let exportSuccess = false;
    this.clientservice.getbulkCandidate(file).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        const blob = new Blob([res], { type: 'application/octet-stream' });
        saveAs(blob, this.fileBulkError);
        exportSuccess = true;
        if (exportSuccess) {
          this.toastrService.success(
            'Résultat de fichier importé a été exporté avec succès'
          );
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastrService.error(serverError);
      },
    });
  }

  createClient() {
    this.spinner.show();
    // Récupérer l'année de la date directement depuis le formulaire
    let date: any = new Date(this.formclient.get('year_of_creation')?.value);
    let yearOfCreation = date?.getFullYear();
    if (!this.isexistname) {
      this.setValidatorRequirements();
      
      this.formclient
        .get('related_phone_ESN')
        ?.setValue(this.formclient.get('related_phone_ESN')?.value?.internationalNumber);
  
      this.formclient.patchValue({
        year_of_creation: yearOfCreation 
      });
  
      this.clientservice
        .createclient(this.formclient.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(this.toastMessages.success);
            this.formclient.reset();
            this.closeModal();
            this.getListclient();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error.message['name']) {
                this.toastrService.error(this.toastMessages.error);
              } else {
                this.toastrService.error(serverError);
              }
            }
          },
        });
    } else {  
      let data = {
        client_id: this.client_id,
        related_first_name_ESN: this.formclient.value.related_first_name_ESN,
        related_email_ESN: this.formclient.value.related_email_ESN,
        related_last_name_ESN: this.formclient.value.related_last_name_ESN,
        related_phone_ESN: this.formclient.value?.related_phone_ESN?.number,
        date_first_presentation: this.formclient.value.date_first_presentation,
        nb_days: this.formclient.value.nb_days,
        year_of_creation: yearOfCreation // Ajouter l'année dans les données
      };
  
      this.clientservice
        .createclient(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(this.toastMessages.success);
            this.formclient.reset();
            this.closeModal();
            this.getListclient();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error.message['name']) {
                this.toastrService.error(this.toastMessages.error);
              } else {
                this.toastrService.error(serverError);
              }
            }
          },
        });
    }

  }
  updateClient() {
   this.formclient
        .get('related_phone_ESN')
        ?.setValue(this.formclient
          .get('related_phone_ESN')?.value?.internationalNumber);
          let date: any = new Date(this.formclient.get('year_of_creation')?.value);
          let yearOfCreation = date?.getFullYear();
          this.formclient.patchValue({
            year_of_creation: yearOfCreation 
          });
    this.clientservice.updateClient(this.formclient.value).subscribe({
      next: (res: any) => {
        this.toastrService.success('Mail modifier avec succès.');
        this.getListclient();
        this.closeModal();
      },
      error: () => {
        this.toastrService.error(serverError);
      },
    });
  }

  setValidatorRequirements() {
    if (
      !this.formclient.get('linkedin_link')?.value ||
      this.formclient.get('linkedin_link')?.value == ''
    ) {
      this.formclient
        .get('website_link')
        ?.setValidators([Validators.required, Validators.pattern(urlRegExp)]);
      this.formclient.get('website_link')!.updateValueAndValidity();
      this.formclient.get('linkedin_link')?.clearValidators();
      this.formclient.get('linkedin_link')?.updateValueAndValidity();
    }
    if (this.formclient.get('website_link')?.value == '') {
      this.formclient
        .get('linkedin_link')
        ?.setValidators([
          Validators.required,
          Validators.pattern(linkedCompanyRegExp),
        ]);
      this.formclient.get('linkedin_link')!.updateValueAndValidity();
      this.formclient.get('website_link')?.clearValidators();
      this.formclient
        .get('website_link')
        ?.setValidators(Validators.pattern(urlRegExp));
      this.formclient.get('website_link')?.updateValueAndValidity();
    }
  }
  closeModal() {
    this.toggleFormFieldsUpdate(true)
    this.formclient.reset();
    this.modalRef!.hide();
  }
  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    // this.formchapitre = this.createchapitreForm(data);
    this.clientSearchErrorMessage = '';
  }
  openModalupdate(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    this.clientSearchErrorMessage = '';
    this.toggleFormFieldsUpdate(false)
    if (data) {
      this.id = data.company.uuid;
      // Créer le formulaire avec les données de la compagnie
      this.formclient = this.createclientForm(data.company);
  
      // Vérification de `year_of_creation`
      if (data.company.year_of_creation === null || data.company.year_of_creation === 'null') {
   
        this.formclient.get('year_of_creation')?.setValue('');
      } else {
        // Sinon, on met la valeur réelle de `year_of_creation`
        this.formclient.get('year_of_creation')?.setValue(data.company.year_of_creation);
      }
    }
  }
  
 
  getclientByName(event: any) {
    this.clientservice.getclientbyname(event.target.value).subscribe({
      next: (res) => {
        if (res.status === 200) {
          this.isexistname = true;
          this.client_id = res.data.uuid;
          this.formclient.patchValue({
            linkedin_link: res.data.linkedin_link,
            country: res.data.country,
            address: res.data.address,
            website_link: res.data.website_link,
            year_of_creation: res.data.year_of_creation,
            domain: res.data.domain,
            type: res.data.type,
            fournisseur_id: res.data.uuid,
            ContactEmail: res.data.ContactEmail,
          });
          this.toggleFormFieldsUpdate(false)
        }
      },
      error: (error) => {       
        this.isexistname = false;
        this.formclient.patchValue({
          linkedin_link: "",
          country: null,
          address: null,
          website_link:  "",
          year_of_creation:  "",
          domain:  "",
          type:  "",
          fournisseur_id:  "",
          ContactEmail:  "",
        });
        this.toggleFormFieldsUpdate(true)
        if (
          error?.status === 400 &&
          error?.error?.message === 'client already associated to this company'
        ) {
          this.clientSearchErrorMessage = error?.error?.message;
        } else {
          this.clientSearchErrorMessage = '';
        }
      },
    });
  }

  onPageChange(e: PageEvent): void {
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;
    if (this.searchForm.dirty) {
      this.applyFilter();
    } 
    else {
      this.getListclient();
    }
  }
  onRatingChange(newRating: number) {
    if (newRating < 1) {
      this.client.average_note = 1;
    } else {
      this.client.average_note = newRating;
    }
  }
  onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.searchForm.get('city')?.setValue(null);
    }
  }

  getListclient() {
        const params = {
          per_page: this.pageSize,
          page: this.currentPage}      
    this.spinner.show();
    this.clientservice.getListclient(params).subscribe({
      next: (response: any) => {
        if (response?.data?.data) {
          this.listclients = response.data.data
          this.totalItems = response.data.total;
          this.spinner.hide();
          this.loadSpinnerTable = false;
        }
      },
      error: (error: any) => {
        this.spinner.hide();
      },
    });
  }
  createSearchForm() {
     return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }

  applyFilter(pageNumber : number = this.currentPage) {
    let valueForm = this.searchForm.value;
    // let filterValue = (event?.target as HTMLInputElement)?.value;
    let data = {
      per_page: this.pageSize,
      page: pageNumber,
      search: this.transformSearch(valueForm?.search),
    };
    this.spinner.show();
    this.clientservice
      .searchClientESN(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if(this.startSearching == true) {
            this.startSearching = false;
          }    
          this.listclients = res.data.data.slice(0, this.endIndex);
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

    transformSearch(search: string): string {
    search = (search || '').replace(/\|\|/g, ' OR ');
    search = search.replace(/&&/g, ' AND ');
    search = search.replace(/!/g, ' NOT ');
    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');
    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });
    search = search.replace(/\s+/g, ' ');
    return search.trim();
  }
  deleteclient(uuid: any) {
    Swal.fire({
      title: 'Confirmez-vous la suppression de ce client ?',
      icon: 'question',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui',
      reverseButtons: true,
      customClass: {
        popup: 'swal2-popup-custom'  // On applique un style simple et direct
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.clientservice.deleteclientt(uuid).subscribe((res: any) => {
          this.toastrService.success('Client a été supprimé avec succès');
          this.getListclient();
        // const existingIndex = this.listclients.findIndex((client: any) => client?.company?.uuid === uuid);
        // if (existingIndex !== -1) {
        //   this.listclients.splice(existingIndex, 1);
        // }
      });
      }
    });
  }
  
  
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Retirer tout caractère qui n'est pas un chiffre, un slash ou un espace
    input.value = input.value.replace(/[^0-9\/]/g, '');
  }

  getListElementHeader() {
    if (!this.typeintervenant) {
      this.clientservice
        .getHeaderElements(14)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            // @TEMPORARY : temporary hidden
            this.dataHeader = res.data?.filter((item: { name: string; }) => item.name !== "nombre des consultant en mission");;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => { },
        });
    } else {
      this.clientservice
        .listPageActorclientIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.isLoadSpinner = false;
            this.dataHeader = res.data;
           
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => { },
        });
    }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      let payload = {
        sub_page_id: data?.id,
      };
      this.clientservice
        .changeDelectedElementHeader(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => { },
          error: () => { },
        });
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.clientservice
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => { },
          error: () => { },
        });
    }
  }

  /**
 * Toggles the enabled state of specified form controls in the `formclient` form group.
 *
 * This function enables or disables the following controls based on the `isEnabled` parameter:
 * - `country`
 * - `address`
 * - `year_of_creation`
 * - `linkedin_link`
 * - `website_link`
 *
 * @param {boolean} isEnabled - Pass `true` to enable the fields, or `false` to disable them.
 */
    toggleFormFieldsUpdate(isEnabled: boolean): void {
      if (this.formclient) {
          const action = isEnabled ? 'enable' : 'disable';
          this.formclient.get('country')?.[action]();
          this.formclient.get('address')?.[action]();
          this.formclient.get('year_of_creation')?.[action]();
          this.formclient.get('linkedin_link')?.[action]();
          this.formclient.get('website_link')?.[action]();
      }
    }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
    this.getListclient()
  }
  openLink(link:any){
    if (link) {
      const fullUrl = link.startsWith('http') ? link : `https://${link}`;
      window.open(fullUrl, '_blank','noopener,noreferrer');
    }
  }
}
